import { render, staticRenderFns } from "./WordingEdit.vue?vue&type=template&id=e26aa966&scoped=true&"
import script from "./WordingEdit.vue?vue&type=script&lang=js&"
export * from "./WordingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26aa966",
  null
  
)

export default component.exports